// error code
export const EMAIL_FORMAT_INVALID = 60;
export const STATUS_INVALID = 4002;
export const ROLE_ID_INVALID = 4003;
export const FRANCHISEE_ID_INVALID = 4004;
export const ACCOUNT_ALREADY_EXISTS = 4091;
export const ACCOUNT_IS_DISABLED = 4092;
